import { Link } from "react-router-dom";
import { AGENT_LOGIN_URL, BROKER_LOGIN_URL, appUrl } from "../config";
import { useJourneyAuth } from "../auth/AuthContext";

export default function Support() {
  const { session, role } = useJourneyAuth();
  const manualTo = session && role && role !== "admin" ? `/manuals/${role}` : "/manuals";
  const tourRole = role === "broker" ? "broker" : "agent";

  return (
    <article className="prose-page" data-tour="support-page">
      <h1>Support</h1>
      <p className="lead">
        Help for the companion, in one place. Manuals are the book. The Guided Tour is the film.
        REChecklist is the desk.
      </p>

      <ul className="door-list" data-tour="support-index">
        <li data-tour="support-door-0">
          <Link to={manualTo}>User manuals</Link>
          <span>Sign in as buyer, seller, agent, or broker. Topical index and search — not A–Z.</span>
        </li>
        <li data-tour="support-door-1">
          <Link to={`/support/tour?role=${tourRole}`}>Guided Tour</Link>
          <span>Motion for agents and brokers. Jump-ahead stays locked until the first complete viewing.</span>
        </li>
        <li data-tour="support-door-2">
          <Link to="/faq">FAQ</Link>
          <span>Short answers. Contact is for everything else.</span>
        </li>
        <li data-tour="support-door-3">
          <Link to="/contact">Contact</Link>
          <span>Write to us when a page in the book is not enough.</span>
        </li>
        <li data-tour="support-door-4">
          <Link to="/vendors">Vendors</Link>
          <span>A placeholder directory — not a marketplace.</span>
        </li>
        <li data-tour="support-door-5">
          <Link to="/events">Events and calendar</Link>
          <span>San Diego County first. Hub events can appear on the REChecklist desk calendar.</span>
        </li>
        <li data-tour="support-door-6">
          <Link to="/community">Community</Link>
          <span>A quiet board for meetings, training, and market notes.</span>
        </li>
        <li data-tour="support-door-7">
          <Link to="/pay">Billing</Link>
          <span>Seat talk stays here. App login stays on REChecklist.</span>
        </li>
      </ul>

      <section className="prose-block" data-tour="support-write">
        <h2>Write to us</h2>
        <p>
          Choose the door that fits. During the Beta Tester Program, replies may take a short while
          — we still read every note.
        </p>
        <ul className="door-list">
          <li>
            <a href="mailto:sysadmin@rechecklist.pro">sysadmin@rechecklist.pro</a>
            <span>Invited Beta access, and when something is not working.</span>
          </li>
          <li>
            <a href="mailto:support@rechecklist.pro">support@rechecklist.pro</a>
            <span>A general hand.</span>
          </li>
          <li>
            <a href="mailto:recprosupport@rechecklist.pro">recprosupport@rechecklist.pro</a>
            <span>Using REChecklist day to day.</span>
          </li>
          <li>
            <a href="mailto:billing@rechecklist.pro">billing@rechecklist.pro</a>
            <span>Seats and invoices.</span>
          </li>
          <li>
            <a href="mailto:payments@rechecklist.pro">payments@rechecklist.pro</a>
            <span>A payment you have made, or hope to make.</span>
          </li>
          <li>
            <a href="mailto:admin@rechecklist.pro">admin@rechecklist.pro</a>
            <span>Your office or your account.</span>
          </li>
        </ul>
      </section>

      <section className="prose-block">
        <h2>Open the desk</h2>
        <p>
          <a href={appUrl("/login")}>Buyers</a>
          {" · "}
          <a href={appUrl("/seller/login")}>Sellers</a>
          {" · "}
          <a href={AGENT_LOGIN_URL}>Agents</a>
          {" · "}
          <a href={BROKER_LOGIN_URL}>Brokers</a>
        </p>
      </section>
    </article>
  );
}
